import { AUTO_ADVANCE_HASH_FLAG } from "@wbly/common";

// Exact match: the hash carries nothing else, so normalising or substring-matching
// would silently accept a typo'd or unrelated flag.
export function shouldAutoAdvance(hash: string): boolean {
  return hash === AUTO_ADVANCE_HASH_FLAG;
}

// Read at module load: seeding the customisation from the URL strips the hash before this
// step mounts, so a read at effect time would always miss it.
let isPending =
  typeof window !== "undefined" && shouldAutoAdvance(window.location.hash);

export function isAutoAdvancePending(): boolean {
  return isPending;
}

// Single-use: going Back to step one remounts it, and it must not submit itself again.
export function markAutoAdvanceDone(): void {
  isPending = false;
}
